import React from 'react';
import { 
  Scale, 
  AlertTriangle, 
  CheckCircle, 
  Ban, 
  XCircle, 
  FileWarning,  
  CreditCard,
  Building
} from 'lucide-react';
import { Link } from 'react-router-dom';

const TermosServico = () => {
  return (
    <div className="min-h-screen bg-[#f8fafc] font-sans text-slate-700 py-12 px-6 sm:px-10 overflow-x-hidden">
      
      {/* CABEÇALHO */}
      <div className="max-w-3xl mx-auto mb-12 text-center">
        
        {/* LOGO ADICIONADA AQUI E ENVOLVIDA EM UM LINK PARA A HOME */}
        <Link to="/" className="inline-block transition-transform hover:scale-105">
          <img 
            src="/logo-sincro2.png" 
            alt="Agenda Sincro" 
            className="h-14 sm:h-16 w-auto mx-auto mb-6 object-contain"
          />
        </Link>
        
        <br/>
        <div className="inline-flex items-center justify-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-xs font-black uppercase tracking-widest">
          <Scale size={16} />
          Termos e Condições Gerais de Uso
        </div>
        <p className="mt-6 text-sm font-medium text-slate-500">
          Última atualização: 26 de Maio de 2026.
        </p>
      </div>

      <div className="max-w-3xl mx-auto flex flex-col gap-6">

        {/* INTRODUÇÃO */}
        <div className="bg-white p-8 sm:p-10 rounded-[32px] border border-slate-100 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.05)]">
          <h2 className="flex items-center gap-3 text-lg font-black text-slate-900 uppercase tracking-wide mb-4">
            <Building size={24} className="text-blue-600" /> 
            1. Aceitação e Objeto
          </h2>
          <p className="text-sm leading-relaxed text-slate-600 font-medium mb-4">
            Ao acessar e utilizar o <strong>Agenda Sincro</strong>, plataforma desenvolvida e mantida pela <strong>Futurae Tecnologia e Consultoria</strong>, o Usuário concorda expressamente com estes Termos de Serviço.
          </p>
          <p className="text-sm leading-relaxed text-slate-600 font-medium">
            O sistema é uma ferramenta de Software as a Service (SaaS) que provê integração técnica de agendamentos entre o Google Calendar e o WhatsApp, automatizando fluxos de resposta e lembretes com base nos dados fornecidos pelo próprio Usuário.
          </p>
        </div>

        {/* ALERTA CRÍTICO (ISENÇÃO DE RESPONSABILIDADE) */}
        <div className="bg-rose-50 p-8 sm:p-10 rounded-[32px] border border-rose-200 shadow-sm relative overflow-hidden">
          <div className="absolute top-0 right-0 p-4 opacity-10 pointer-events-none">
            <AlertTriangle size={120} className="text-rose-500" />
          </div>
          <h3 className="flex items-center gap-3 text-lg font-black text-rose-800 uppercase tracking-wide mb-4 relative z-10">
            <FileWarning size={24} className="text-rose-600" /> 
            Isenção de Responsabilidade Técnica
          </h3>
          <p className="text-sm leading-relaxed text-rose-900 font-semibold relative z-10">
            O Usuário declara expressa ciência de que o Agenda Sincro depende exclusivamente do funcionamento de APIs de terceiros (Google e Meta/WhatsApp). <strong>NÃO GARANTIMOS</strong> o funcionamento ininterrupto do serviço em caso de mudanças repentinas nas políticas destas empresas, atualizações forçadas de API ou instabilidades globais em seus servidores.
          </p>
        </div>

        {/* WHATSAPP E BLOQUEIOS */}
        <div className="bg-white p-8 sm:p-10 rounded-[32px] border border-slate-100 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.05)]">
          <h2 className="flex items-center gap-3 text-lg font-black text-slate-900 uppercase tracking-wide mb-4">
            <Ban size={24} className="text-amber-500" /> 
            2. Risco de Bloqueio (WhatsApp)
          </h2>
          <p className="text-sm leading-relaxed text-slate-600 font-medium mb-4">
            O uso de qualquer tipo de automação no WhatsApp está sujeito aos Termos de Serviço da Meta. O Usuário é o único e exclusivo responsável pelo teor e volume do conteúdo enviado através de nossa plataforma.
          </p>
          <ul className="flex flex-col gap-3 text-sm text-slate-600 font-medium">
            <li className="flex items-start gap-2">
              <span className="text-amber-500 mt-0.5">▪</span>
              <strong>NÃO NOS RESPONSABILIZAMOS</strong> por números de WhatsApp banidos, bloqueados ou suspensos temporária/definitivamente.
            </li>
            <li className="flex items-start gap-2">
              <span className="text-amber-500 mt-0.5">▪</span>
              O Usuário reconhece que o envio de mensagens não solicitadas (Spam) ou disparos em massa indiscriminados que resultem em denúncias são de sua inteira responsabilidade legal e técnica.
            </li>
          </ul>
        </div>

        {/* LIMITAÇÃO DE DANOS */}
        <div className="bg-white p-8 sm:p-10 rounded-[32px] border border-slate-100 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.05)]">
          <h2 className="flex items-center gap-3 text-lg font-black text-slate-900 uppercase tracking-wide mb-4">
            <XCircle size={24} className="text-slate-500" /> 
            3. Limitação de Danos
          </h2>
          <p className="text-sm leading-relaxed text-slate-600 font-medium mb-4">
            Em nenhum caso o Agenda Sincro, seus desenvolvedores ou a Futurae Tecnologia e Consultoria serão responsabilizados legal ou financeiramente por:
          </p>
          <ul className="flex flex-col gap-3 text-sm text-slate-600 font-medium bg-slate-50 p-6 rounded-2xl">
            <li className="flex items-center gap-2"><CheckCircle size={16} className="text-slate-400" /> Lucros cessantes decorrentes de falhas no agendamento automático.</li>
            <li className="flex items-center gap-2"><CheckCircle size={16} className="text-slate-400" /> Perda de dados por má configuração da ferramenta por parte do Usuário.</li>
            <li className="flex items-center gap-2"><CheckCircle size={16} className="text-slate-400" /> Consultas marcadas em horários indevidos por falha na sincronização de fuso horário local.</li>
            <li className="flex items-center gap-2"><CheckCircle size={16} className="text-slate-400" /> Danos indiretos, incidentais ou punitivos de qualquer natureza.</li>
          </ul>
        </div>

        {/* ASSINATURA E CANCELAMENTO */}
        <div className="bg-white p-8 sm:p-10 rounded-[32px] border border-slate-100 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.05)]">
          <h2 className="flex items-center gap-3 text-lg font-black text-slate-900 uppercase tracking-wide mb-4">
            <CreditCard size={24} className="text-emerald-500" /> 
            4. Assinatura e Cancelamento
          </h2>
          <p className="text-sm leading-relaxed text-slate-600 font-medium">
            O Usuário pode cancelar o serviço e interromper a cobrança recorrente a qualquer momento através do seu painel de controle. No entanto, por se tratar de um serviço de consumo imediato e reserva contínua de infraestrutura de servidores, <strong>não haverá reembolso pro-rata</strong> de mensalidades já processadas e pagas, independentemente do uso efetivo ou não da plataforma no período vigente.
          </p>
        </div>

        {/* FORO */}
        <div className="bg-white p-8 sm:p-10 rounded-[32px] border border-slate-100 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.05)]">
          <h2 className="flex items-center gap-3 text-lg font-black text-slate-900 uppercase tracking-wide mb-4">
            <Scale size={24} className="text-indigo-500" /> 
            5. Foro e Legislação Aplicável
          </h2>
          <p className="text-sm leading-relaxed text-slate-600 font-medium">
            Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o Foro da Comarca de <strong>Fortaleza, Ceará</strong>, para dirimir quaisquer dúvidas, controvérsias ou litígios oriundos destes Termos, com renúncia expressa a qualquer outro, por mais privilegiado que seja ou venha a ser.
          </p>
        </div>

      </div>
    </div>
  );
};

export default TermosServico;